const MergeTwoArrayFunc = (array1, array2) => {
    const mergedArray = array1.concat(array2).filter((item, index, self) =>
    index === self.findIndex((t) => t.question === item.question)
  );
    return mergedArray;
}

export default MergeTwoArrayFunc;